<template>
  <div class="row">
    <div class="col-md-12">
      <h1 class="text-center">Upload Marketing Country Cost Data</h1>
      <h4 class="text-center cursor" @click="$router.push('v2')">Go to V2</h4>
      <div class="card text-center mb-4" style="max-width: 600px; margin:auto">
        <div class="card-header text-center">
          APP
        </div>
        <div class="card-body">
          <div class="form-group">
            <select class="form-control text-center" v-model="app">
              <option :value="undefined" disabled>Choose App</option>
              <option v-for="(key, value) in apps" :value="value" :key="key">{{ key }}</option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="card">
        <div class="card-header text-center">
          Add Data
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-8">
              <form action="#">
                <label>Date</label>
                <div class="form-group">
                  <input type="text" class="form-control" placeholder="YYYY-MM-DD" maxlength="10" minlength="10" v-model="date">
                </div>
                <label>Country</label>
                <div class="form-group">
                  <input type="text" class="form-control" placeholder="__" maxlength="3" v-model="country">
                </div>
                <label>Platform</label>
                <div class="form-group">
                  <input type="text" class="form-control" placeholder="Ex: FB SKAD" v-model="platform">
                </div>
                <label>Cost</label>
                <div class="form-group">
                  <input type="number" class="form-control" placeholder="0.00" v-model.number="cost">
                </div>
              </form>
            </div>
            <div class="col-md-4">
              <label>Uploading from</label>
              <div class="form-group">
                <select class="form-control text-center" v-model="csvPlatform">
                  <option :value="undefined" disabled>Choose Platform</option>
                  <option v-for="(value, index) in platformOptions" :value="value" :key="`platform-select-${index}`">{{ value }}</option>
                </select>
              </div>
              <label>Upload CSV</label>
              <div>
                <input type="file" class="form-control" @change="importCSV">
              </div>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <button type="submit" class="btn btn-sm btn-fill btn-primary" @click="addRow()">Add new row to buffer</button>
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="card">
        <div class="card-header text-center">
          <h4 class="card-title">Buffer</h4>
        </div>
        <div class="card-body">
          <div class="table-responsive">
            <table class="table tablesorter tablesorter-default tablesorter4f4f39ffa083a" id="simple-table" role="grid">
              <thead class=" text-primary">
                <tr role="row" class="tablesorter-headerRow">
                  <th data-column="0" class="tablesorter-header tablesorter-headerUnSorted" tabindex="0" scope="col" role="columnheader" aria-disabled="false" aria-controls="simple-table" unselectable="on" aria-sort="none" aria-label="Date: No sort applied, activate to apply an ascending sort" style="user-select: none;"><div class="tablesorter-header-inner">
                    DATE
                  </div></th>
                  <th data-column="1" class="tablesorter-header tablesorter-headerUnSorted" tabindex="0" scope="col" role="columnheader" aria-disabled="false" aria-controls="simple-table" unselectable="on" aria-sort="none" aria-label="Country: No sort applied, activate to apply an ascending sort" style="user-select: none;"><div class="tablesorter-header-inner">
                    COUNTRY
                  </div></th>
                  <th data-column="1" class="tablesorter-header tablesorter-headerUnSorted" tabindex="0" scope="col" role="columnheader" aria-disabled="false" aria-controls="simple-table" unselectable="on" aria-sort="none" aria-label="Country: No sort applied, activate to apply an ascending sort" style="user-select: none;"><div class="tablesorter-header-inner">
                    PLATFORM
                  </div></th>
                  <th class="text-center tablesorter-header tablesorter-headerUnSorted" data-column="2" tabindex="0" scope="col" role="columnheader" aria-disabled="false" aria-controls="simple-table" unselectable="on" aria-sort="none" aria-label="Cost: No sort applied, activate to apply an ascending sort" style="user-select: none;"><div class="tablesorter-header-inner">
                    COST
                  </div></th>
                  <th class="text-center tablesorter-header tablesorter-headerUnSorted" data-column="3" tabindex="0" scope="col" role="columnheader" aria-disabled="false" aria-controls="simple-table" unselectable="on" aria-sort="none" aria-label="Delete: No sort applied, activate to apply an ascending sort" style="user-select: none;">
                    <div class="tablesorter-header-inner">
                      DELETE
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody aria-live="polite" aria-relevant="all">
                <tr role="row" v-for="(item, index) in rows" :key="index">
                  <td>
                    {{ item.date }}
                  </td>
                  <td>
                    {{ item.country }}
                  </td>
                  <td>
                    {{ item.platform }}
                  </td>
                  <td class="text-center">
                    ${{ item.cost }}
                  </td>
                  <td>
                    <div class="tablesorter-header-inner text-center">
                      <button class="btn btn-sm btn-danger" @click="removeRow(index)"> DEL </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="card-footer text-center">
          <button type="submit" class="btn btn-sm btn-fill btn-success" @click="uploadToBigQuery">{{ uploadBtnText }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import notify from "../util/notification";
import countryCodes from "@/assets/json/CountryCodes.json"
import tokenManagerService from "../services/tokenManager";

const isLocal = window.location.href.indexOf("localhost") >= 0
const backendUrl = isLocal ? "http://localhost:5002" : ""

export default {
  name: 'HomePage',
  data() {
    return {
      app: undefined,
      date: undefined,
      country: undefined,
      platform: undefined,
      cost: undefined,
      platformOptions: ["facebook", "tiktok", "google", "native x"],
      csvPlatform: undefined,
      state: 'waiting',
      rows: []
    }
  },
  computed: {
    apps() {
      return this.$store.getters.apps
    },
    uploadBtnText() {
      if (this.state == 'waiting'){
        return "Upload Buffer to BigQuery"
      }else if (this.state == 'uploading'){
        return "Uploading to BigQuery..."
      }
    }
  },
  methods: {
    addRow() {
      let isDateValid = true
      const date = new Date(this.date)
      if (!date.getTime()) {isDateValid = false}
      let isCountryValid = typeof this.country == 'string' && this.country.length >= 2 && this.country.length < 4
      let isCostValid = !Number.isNaN(this.cost) && this.cost >= 0 
      if (!isDateValid){
        notify('Date is not valid', 'error')
        return
      }

      if (!isCountryValid){
        notify('Country is not valid', 'error')
        return
      }

      if (!isCostValid){
        notify('Cost is not valid', 'error')
        return
      }

      this.rows.push({
        date: this.date,
        country: this.country,
        platform: this.platform,
        cost: this.cost
      })
      this.date = undefined
      this.country = undefined
      this.platform = undefined
      this.cost = undefined
    },
    removeRow(index) {
      this.rows.splice(index,1)
    },
    async uploadToBigQuery() {
      if (!this.app){
        notify('Please choose an app!', "error")
      }else{
        this.state = 'uploading'
        const token = await tokenManagerService.getValidToken()
        try {
          await axios.post(`${backendUrl}/load`, {
            data: this.rows,
            app: this.app
          }, {
            headers: {
              authorization: `Bearer ${token}`
            }
          })
          notify("Uploaded", "success")
          this.rows = []
          this.state = 'waiting'
        } catch (error) {
          notify("Couldn't upload", "error")
          this.state = 'waiting'
        }
      }
    },
    importCSV(event) {
      const reader = new FileReader();
      const vm = this
      reader.onload = function() {
        const contents = reader.result;
        const rows = contents.split('\r').join("").split('\n');
        rows.shift()
        vm.rows = vm.rows.concat(vm.getData(rows, vm.csvPlatform))
      };

      reader.readAsText(event.target.files[0]);
    },
    getData(rows, csvPlatform) {
      let result = {}
      if (csvPlatform == 'facebook'){
        rows.forEach(row => {
          const [campaignName,day,country,cost] = row.split(',')
          if (cost && country && country != 'unknown'){
            let platform
            if (campaignName.indexOf('web_con') >= 0){
              platform = "FB Web to app Campaigns"
            }else if (campaignName.indexOf('ios14_skad') >= 0 || campaignName.indexOf('skad_ios14') >= 0){
              platform = "FB SKAN Campaigns"
            }else if (campaignName.indexOf('app_install') >= 0){
              platform = "FB NON-SKAN"
            }else {
              console.log(campaignName, row)
              platform = "FB Other"
            }
            const key = day+platform+country
            if (result[key] == undefined){
              result[key] = {
                date: day,
                platform,
                country,
                cost: Number(cost)
              }
            }else {
              result[key].cost += Number(cost)
            }
          }
        })
      }else if (csvPlatform == 'tiktok'){
        rows.forEach(row => {
          let country = ""
          let campaignName = ""
          let day = ""
          let cost = ""
          let _ = ""
          if (row.indexOf('"')>= 0) {
            const parts = row.split('"')
            country = parts[1].split(",").join(", ")
            const otherParts = parts[2].split(',')
            campaignName = otherParts[1]
            day = otherParts[2]
            cost = otherParts[3]
          }else{
            [country,campaignName,day,cost] = row.split(',')
          }
          if (cost && country && country != "-" && day){
            let platform
            if (campaignName.indexOf('skad') >= 0){
              platform = "TikTok SKAN Campaigns"
            }else if (campaignName.indexOf('app_install') >= 0){
              platform = "TikTok NON-SKAN Campaigns"
            }else {
              console.log(campaignName, row)
              platform = "Tiktok Other"
            }
            const key = day+platform+country
            if (result[key] == undefined){
              result[key] = {
                date: day,
                platform,
                country: countryCodes[country],
                cost: Number(cost)
              }
            }else {
              result[key].cost += Number(cost)
            }
          }
        })
      }else if (csvPlatform == 'google'){
        rows.forEach(row => {
          const [day,campaignName,country,currency,cost] = row.split(',')
          if (cost && day != "Day"){
            const platform = "Google Campaigns"
            const key = day+platform+country
            if (result[key] == undefined){
              result[key] = {
                date: day,
                platform,
                country: countryCodes[country],
                cost: Number(cost)
              }
            }else {
              result[key].cost += Number(cost)
            }
          }
        })
      }else if (csvPlatform == 'native x'){
        rows.forEach(row => {
          const [day,cost] = row.split(',')
          const country = "CN"
          if (cost && day != "Day"){
            const platform = "Native X"
            const key = day+platform+country
            if (result[key] == undefined){
              result[key] = {
                date: day.split('/').join('-'),
                platform,
                country,
                cost: Number(cost.split('$')[1])
              }
            }else {
              result[key].cost += Number(cost.split('$')[1])
            }
          }
        })
      }
      return Object.values(result)
    }
  }
}
</script>

<style>
  .pointer {
    cursor: pointer;
  }
</style>